import Home from "./views/Home.vue";
import NotImplemented from "./components/NotImplemented.vue";

import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import asbestosFacilityRoutes, { asbestosFacilityRouteNames } from "./views/asbestosFacility/asbestosFacilityRoutes";
import complaintInvestigationRoutes, {
  complaintInvestigationRouteNames,
} from "./views/complaintInvestigations/complaintInvestigationRoutes";
import { default as complaintRoutes, complaintRouteNames } from "./views/complaint/complaintRoutes";
import constructionProjectRoutes, {
  constructionProjectRouteNames,
} from "./views/constructionProject/constructionProjectRoutes";
import dustFormRoutes, {
  dustFormPermittingRouteNames,
} from "./views/electronicForm/dustControlPermitting/dustFormRoutes";
import organizationsRoutes, { organizationRouteNames } from "./views/organization/organizationRoutes";
import stationarySourceRoutes, { stationarySourceRouteNames } from "./views/stationarySource/stationarySourceRoutes";
import stationarySourcePermittingRoutes, {
  stationarySourcePermittingRouteNames,
} from "./views/electronicForm/stationarySourcePermitting/stationarySourceRoutes";
import vacantLandParcelRoutes, { vacantLandParcelRouteNames } from "./views/vacantLandParcel/vacantLandParcelRoutes";
import invoiceRoutes, { invoiceRouteNames } from "./views/invoice/invoiceRoutes";
import type { RouterOptions } from "vue-router";
import asbestosRoutes, { asbestosRouteNames } from "./views/electronicForm/asbestosForm/asbestosRoutes";
import enforcementRoutes, { enforcementRouteNames } from "./views/electronicForm/enforcementForm/enforcementRoutes";
import electronicFormRoutes, { electronicFormRouteNames } from "./views/electronicForm/electronicFormRoutes";
import dustInspectionRoutes, {
  dustInspectionRouteNames as dustInspectionRouteNames,
} from "./views/dustInspections/dustInspectionRoutes";
import vacantLandInspectionRoutes, {
  vacantLandInspectionRouteNames as vacantLandInspectionRouteNames,
} from "./views/vacantLandInspections/vacantLandInspectionRoutes";
import accessRequestRoutes, { accessRequestRouteNames } from "./views/accessRequest/accessRequestRoutes";
import asbestosProjectRoutes, {
  asbestosProjectRouteNames as asbestosProjectRouteNames,
} from "./views/asbestosProjects/asbestosProjectRoutes";
import asbestosNotificationRoutes, {
  asbestosNotificationRouteNames as asbestosNotificationRouteNames,
} from "./views/asbestosNotifications/asbestosNotificationRoutes";
import asbestosInspectionRoutes, {
  asbestosInspectionRouteNames as asbestosInspectionRouteNames,
} from "./views/asbestosInspections/asbestosInspectionRoutes";
import complaintEnforcementActionRoutes, {
  complaintEnforcementActionRouteNames as complaintEnforcementActionRouteNames,
} from "./views/complaintEnforcementActions/complaintEnforcementActionRoutes";
import dustEnforcementActionRoutes, {
  dustEnforcementActionRouteNames as dustEnforcementActionRouteNames,
} from "./views/dustEnforcementActions/dustEnforcementActionRoutes";
import asbestosEnforcementActionRoutes, {
  asbestosEnforcementActionRouteNames as asbestosEnforcementActionRouteNames,
} from "./views/asbestosEnforcementActions/asbestosEnforcementActionRoutes";
import complianceRoutes, { complianceRouteNames } from "./views/electronicForm/complianceForm/complianceRoutes";
import openBurningRoutes, { openBurningRouteNames } from "./views/electronicForm/openBurningForm/openBurningRoutes";
import sourceTestingRoutes, {
  sourceTestingRouteNames,
} from "./views/electronicForm/sourceTestingForm/sourceTestingRoutes";
import stationarySourceEnforcementActionRoutes, {
  stationarySourceEnforcementActionRouteNames as stationarySourceEnforcementActionRouteNames,
} from "./views/stationarySourceEnforcementActions/stationarySourceEnforcementActionRoutes";
import vacantLandEnforcementActionRoutes, {
  vacantLandEnforcementActionRouteNames as vacantLandEnforcementActionRouteNames,
} from "./views/vacantLandEnforcementActions/vacantLandEnforcementActionRoutes";
import {
  asbestosEnforcementActionRouteName,
  complaintEnforcementActionRouteName,
  dustEnforcementActionRouteName,
  stationarySourceEnforcementActionRouteName,
  vacantLandEnforcementActionRouteName,
} from "./views/enforcementAction/enforcementAction";

import userRoutes, { userRouteNames as userRouteNames } from "./views/user/userRoutes";
import dustClassRoutes, { dustClassRouteNames } from "./views/electronicForm/dustClassRegistration/dustClassRoutes";

import dustRoutes, { dustRouteNames } from "./views/dustClass/dustClassRoutes";
import dustMonitorClassRoutes, { dustMonitorClassRouteNames } from "./views/dustMonitorClass/dustMonitorClassRoutes";

import applicationRoutes, { applicationRouteNames } from "./views/application/applicationRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  notImplemented: "NotImplemented",
  notFound: "NotFound",
  accessRequest: {
    ...accessRequestRouteNames,
  },
  asbestosFacility: {
    ...asbestosFacilityRouteNames,
  },
  complaint: {
    ...complaintRouteNames,
  },
  complaintInvestigation: {
    ...complaintInvestigationRouteNames,
  },
  [complaintEnforcementActionRouteName]: {
    ...complaintEnforcementActionRouteNames,
  },
  constructionProject: {
    ...constructionProjectRouteNames,
  },
  electronicForm: {
    ...asbestosRouteNames,
    ...complianceRouteNames,
    ...enforcementRouteNames,
    ...dustFormPermittingRouteNames,
    ...openBurningRouteNames,
    ...sourceTestingRouteNames,
    ...stationarySourcePermittingRouteNames,
    ...electronicFormRouteNames,
    ...dustClassRouteNames,
  },
  invoice: {
    ...invoiceRouteNames,
  },
  stationarySource: {
    ...stationarySourceRouteNames,
  },
  [stationarySourceEnforcementActionRouteName]: {
    ...stationarySourceEnforcementActionRouteNames,
  },
  vacantLandParcel: {
    ...vacantLandParcelRouteNames,
  },
  [vacantLandEnforcementActionRouteName]: {
    ...vacantLandEnforcementActionRouteNames,
  },
  organization: {
    ...organizationRouteNames,
  },
  dustInspection: {
    ...dustInspectionRouteNames,
  },
  dust: {
    ...dustRouteNames,
  },
  dustMonitorClass: {
    ...dustMonitorClassRouteNames,
  },
  application: {
    ...applicationRouteNames,
  },
  [dustEnforcementActionRouteName]: {
    ...dustEnforcementActionRouteNames,
  },
  vacantLandInspection: {
    ...vacantLandInspectionRouteNames,
  },
  asbestosProject: {
    ...asbestosProjectRouteNames,
  },
  asbestosNotification: {
    ...asbestosNotificationRouteNames,
  },
  asbestosInspection: {
    ...asbestosInspectionRouteNames,
  },
  [asbestosEnforcementActionRouteName]: {
    ...asbestosEnforcementActionRouteNames,
  },
  user: {
    ...userRouteNames,
  },
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  ...accessRequestRoutes,
  ...asbestosEnforcementActionRoutes,
  ...asbestosFacilityRoutes,
  ...asbestosInspectionRoutes,
  ...asbestosProjectRoutes,
  ...asbestosNotificationRoutes,
  ...asbestosRoutes,
  ...complianceRoutes,
  ...complaintRoutes,
  ...complaintEnforcementActionRoutes,
  ...complaintInvestigationRoutes,
  ...constructionProjectRoutes,
  ...dustClassRoutes,
  ...dustEnforcementActionRoutes,
  ...dustFormRoutes,
  ...dustInspectionRoutes,
  ...electronicFormRoutes,
  ...enforcementRoutes,
  ...invoiceRoutes,
  ...organizationsRoutes,
  ...openBurningRoutes,
  ...sourceTestingRoutes,
  ...stationarySourceEnforcementActionRoutes,
  ...stationarySourceRoutes,
  ...stationarySourcePermittingRoutes,
  ...userRoutes,
  ...vacantLandEnforcementActionRoutes,
  ...vacantLandInspectionRoutes,
  ...vacantLandParcelRoutes,
  ...dustRoutes,
  ...applicationRoutes,
  ...dustMonitorClassRoutes,
  {
    path: "/not-found",
    component: NotFound,
    name: routeNames.notFound,
    meta: { title: "Not Found" },
  },
  { path: "/:path(.*)", component: NotFound },
];
